module.exports = __webpack_public_path__ + "img/ih.0ee26f87.svg";